import JSONData from "../variables/variables.json";
import classNames from "classname";
import Image, { getImageProps } from "next/image";
import Link from "next/link";
import TranslatedMessage from "./TranslatedMessage";

const formatPolishDate = (value) => {
	const date = new Date(value);

	if (Number.isNaN(date.getTime())) {
		return value;
	}

	return new Intl.DateTimeFormat("pl-PL", {
		day: "numeric",
		month: "long",
		year: "numeric",
	}).format(date);
};

const formatDateTime = (value) => {
	const date = new Date(value);

	if (Number.isNaN(date.getTime())) {
		return value;
	}

	return date.toISOString().slice(0, 10);
};

import LinkTo from "./mdx/LinkTo";

const Slider = (props) => {
	// PROPS VARIABLE
	let propsMiasto = props.miasto;
	let propsPodatek = props.podatek;

	let slider = "slider";

	let miastoVariable = "miasta." + propsMiasto;

	// SLIDER HEADER
	let headerTitle = miastoVariable + "." + slider + "." + [propsPodatek] + ".header.title";

	let headerSubtitle = miastoVariable + "." + slider + "." + [propsPodatek] + ".header.subtitle";

	// SLIDER BUTTON
	let firstButton =
		miastoVariable + "." + slider + "." + [propsPodatek] + ".action.firstButton.title";

	let secondButton =
		miastoVariable + "." + slider + "." + [propsPodatek] + ".action.secondButton.title";

	// JSON VARIABLE
	let miastoJSON = JSONData.miasta[propsMiasto];

	let heroImg = miastoJSON.slider[propsPodatek].header.images;
	let dataMicroModalTrigger = miastoJSON.slider[propsPodatek].name.shortName;

	// BLOG
	let blog = props.blog;
	let title = props.title;
	let description = props.description;
	let datePublication = props.datePublication;
	let dateUpdate = props.dateUpdate;
	let imageDesktop = props.imageDesktop;
	let imageTablet = props.imageTablet;
	let imageMobile = props.imageMobile;
	let blogWithAction = props.blogWithAction;
	let blogActionText = props.blogActionText;
	let blogActionUrl = props.blogActionUrl;
	let blogMiasto = props.blogMiasto;
	let blogPodatek = props.blogPodatek;
	let blogDataMicroModalTrigger;

	if (blogWithAction === "dialog") {
		blogDataMicroModalTrigger = JSONData.miasta[blogMiasto].slider[blogPodatek].name.shortName;
	}

	const Hero = (props) => (
		<section
			className={classNames("pd-hero", {
				small: props.small,
				slider: props.slider,
			})}
			style={{
				position: "relative",
			}}
		>
			{props.children}
		</section>
	);

	const HeroTop = (props) => (
		<div
			className="pd-hero__top"
			style={{
				position: "relative",
				zIndex: 5,
			}}
		>
			<div className="pd-hero__header">{props.children}</div>
		</div>
	);

	const HeroTitle = (props) => (
		<h1 className="pd-hero__header__title" id={props.id}>
			{props.children}
		</h1>
	);

	const HeroSubtitle = (props) => <p className="pd-hero__header__subtitle">{props.children}</p>;

	const HeroDate = () => {
		if (!dateUpdate) {
			return null;
		}

		return (
			<div className="pd-hero__header__date">
				<div className="pd-hero__header__date__item">
					<Image
						unoptimized
						width={18}
						height={18}
						alt=""
						src="https://przyjazne-deklaracje.pl/resources/images/icons/general/files/icon-calendar.svg"
					/>
					<span className="pd-hero__header__date__time">
						Ostatnia aktualizacja:&nbsp;
						<time dateTime={formatDateTime(dateUpdate)}>
							{formatPolishDate(dateUpdate)}
						</time>
					</span>
				</div>
			</div>
		);
	};

	const HeroImage = (props) => (
		<div
			className="pd-hero__image"
			style={{
				pointerEvents: "none",
			}}
		>
			{props.children}
		</div>
	);

	const HeroImageDesktop = (props) => (
		<div
			className="pd-hero__image__img desktop"
			style={{
				pointerEvents: "none",
			}}
		>
			{props.children}
		</div>
	);

	const HeroImageTablet = (props) => (
		<div
			className="pd-hero__image__img tablet"
			style={{
				pointerEvents: "none",
			}}
		>
			{props.children}
		</div>
	);

	const HeroImageMobile = (props) => (
		<div
			className="pd-hero__image__img mobile"
			style={{
				pointerEvents: "none",
			}}
		>
			{props.children}
		</div>
	);

	const HeroImageResponsive = (props) => (
		<picture
			className="pd-hero__image__img"
			style={{
				pointerEvents: "none",
			}}
		>
			{props.children}
		</picture>
	);

	if (blog && blogWithAction) {
		propsPodatek = blogPodatek;
	}

	// LINK
	let startUrl;
	let startUrlProd = "https://przyjazne-deklaracje.pl/";
	let startUrlTest = "https://test.przyjazne-deklaracje.pl/";

	if (JSONData.miasta[propsMiasto].test) {
		startUrl = startUrlTest;
	} else {
		startUrl = startUrlProd;
	}

	let profileCode = "O4B";
	let templateCode = miastoJSON.slider[propsPodatek].templateCode;
	let templateScope = JSONData.miasta[propsMiasto].templateScope;
	let templateScopeFull = "&templateScope=" + templateScope;

	if (miastoJSON.index) {
		templateScopeFull = "";
	}

	let linkTo =
		startUrl +
		"kalkulatory/menadzer/menadzer-kalkulatorow?profileCode=" +
		profileCode +
		"&templateCode=" +
		templateCode +
		templateScopeFull;

	const useOptimizedHomepageHero = !props.small && !blog && propsPodatek === "index";

	let homepageHeroDesktop;
	let homepageHeroTablet;
	let homepageHeroMobile;

	if (useOptimizedHomepageHero) {
		homepageHeroDesktop = getImageProps({
			alt: "",
			src: heroImg.desktop,
			width: 1920,
			height: 488,
			quality: 85,
			sizes: "100vw",
		}).props;

		homepageHeroTablet = getImageProps({
			alt: "",
			src: heroImg.tablet,
			width: 1920,
			height: 488,
			quality: 85,
			sizes: "100vw",
		}).props;

		homepageHeroMobile = getImageProps({
			alt: "",
			src: heroImg.mobile,
			width: 1920,
			height: 800,
			quality: 85,
			sizes: "100vw",
		}).props;
	}

	return (
		<>
			<Hero small={props.small} slider={props.slider}>
				<HeroTop>
					<HeroTitle>{!blog ? <TranslatedMessage id={headerTitle} /> : title}</HeroTitle>
					<HeroSubtitle>
						{!blog ? <TranslatedMessage id={headerSubtitle} /> : description}
					</HeroSubtitle>
					{blog && <HeroDate />}
				</HeroTop>

				{blogWithAction === "dialog" && (
					<div
						className="pd-hero__action"
						style={{
							position: "relative",
							zIndex: 10,
						}}
					>
						<div
							className={classNames("pd-hero__action__inner", {
								"pd-hero__action--to-left": props.small,
							})}
							style={{
								position: "relative",
								zIndex: 11,
							}}
						>
							{JSONData.miasta[blogMiasto].slider[blogPodatek].action.firstButton.turnModal ? (
								<button
									type="button"
									data-a11y-dialog-show={blogDataMicroModalTrigger}
									aria-haspopup="dialog"
									aria-controls={blogDataMicroModalTrigger}
									className="pd-btn pd-btn--primary"
									style={{
										position: "relative",
										zIndex: 12,
										touchAction: "manipulation",
									}}
								>
									{blogActionText}
								</button>
							) : JSONData.miasta[blogMiasto].slider[blogPodatek].action.firstButton.turnUrl ? (
								<Link
									href={JSONData.miasta[blogMiasto].slider[blogPodatek].action.firstButton.url}
									className="pd-btn pd-btn--primary"
								>
									{blogActionText}
								</Link>
							) : (
								<Link href={linkTo} className="pd-btn pd-btn--primary">
									{blogActionText}
								</Link>
							)}
						</div>
					</div>
				)}

				{blogWithAction === "link" && (
					<div
						className="pd-hero__action"
						style={{
							position: "relative",
							zIndex: 10,
						}}
					>
						<div
							className={classNames("pd-hero__action__inner", {
								"pd-hero__action--to-left": props.small,
							})}
							style={{
								position: "relative",
								zIndex: 11,
							}}
						>
							<Link href={blogActionUrl} className="pd-btn pd-btn--primary">
								{blogActionText}
							</Link>
						</div>
					</div>
				)}

				{!blog && miastoJSON.slider[propsPodatek].action.available && (
					<div
						className="pd-hero__action"
						style={{
							position: "relative",
							zIndex: 10,
						}}
					>
						<div
							className={classNames("pd-hero__action__inner", {
								"pd-hero__action--two-buttons":
									miastoJSON.slider[propsPodatek].action.secondButton.available,
								"pd-hero__action--two-buttons--no-mobile":
									!miastoJSON.slider[propsPodatek].action.secondButton.availableMobile,
								"pd-hero__action--to-left": props.small,
							})}
							style={{
								position: "relative",
								zIndex: 11,
							}}
						>
							{miastoJSON.slider[propsPodatek].action.firstButton.scrollTo ? (
								<LinkTo to="wypelnij-deklaracje" className="pd-btn pd-btn--primary">
									<TranslatedMessage id={firstButton} />
								</LinkTo>
							) : miastoJSON.slider[propsPodatek].action.firstButton.turnModal ? (
								<button
									type="button"
									data-a11y-dialog-show={dataMicroModalTrigger}
									aria-haspopup="dialog"
									aria-controls={dataMicroModalTrigger}
									className="pd-btn pd-btn--primary"
									style={{
										position: "relative",
										zIndex: 12,
										touchAction: "manipulation",
									}}
								>
									<TranslatedMessage id={firstButton} />
								</button>
							) : miastoJSON.slider[propsPodatek].action.firstButton.turnUrl ? (
								<Link
									href={miastoJSON.slider[propsPodatek].action.firstButton.url}
									className="pd-btn pd-btn--primary"
								>
									<TranslatedMessage id={firstButton} />
								</Link>
							) : (
								<Link href={linkTo} className="pd-btn pd-btn--primary">
									<TranslatedMessage id={firstButton} />
								</Link>
							)}

							{miastoJSON.slider[propsPodatek].action.secondButton.available === true &&
								(miastoJSON.slider[propsPodatek].action.secondButton.scrollTo ? (
									<LinkTo to="czytaj-wiecej" className="pd-btn pd-btn--outline read-more">
										<TranslatedMessage id={secondButton} />
									</LinkTo>
								) : (
									<Link
										href={miastoJSON.slider[propsPodatek].action.secondButton.url}
										className="pd-btn pd-btn--primary"
									>
										<TranslatedMessage id={secondButton} />
									</Link>
								))}
						</div>
					</div>
				)}

				{props.small ? (
					props.blog ? (
						<HeroImage>
							<HeroImageDesktop>
								<Image
									unoptimized
									alt=""
									src={imageDesktop}
									quality={100}
									priority
									fill={true}
									sizes="100vw"
									style={{
										objectFit: "contain",
										objectPosition: "right bottom",
										pointerEvents: "none",
									}}
								/>
							</HeroImageDesktop>
							<HeroImageTablet>
								<Image
									unoptimized
									alt=""
									src={imageTablet}
									quality={100}
									priority
									fill={true}
									sizes="100vw"
									style={{
										objectFit: "contain",
										objectPosition: "right bottom",
										pointerEvents: "none",
									}}
								/>
							</HeroImageTablet>
							<HeroImageMobile>
								<Image
									unoptimized
									alt=""
									src={imageMobile}
									quality={100}
									priority
									fill={true}
									sizes="100vw"
									style={{
										objectFit: "contain",
										objectPosition: "right bottom",
										pointerEvents: "none",
									}}
								/>
							</HeroImageMobile>
						</HeroImage>
					) : (
						<HeroImage>
							<HeroImageDesktop>
								<Image
									unoptimized
									alt=""
									src={heroImg.desktop}
									quality={100}
									priority
									fill={true}
									sizes="100vw"
									style={{
										objectFit: "contain",
										objectPosition: "right bottom",
										pointerEvents: "none",
									}}
								/>
							</HeroImageDesktop>
							<HeroImageTablet>
								<Image
									unoptimized
									alt=""
									src={heroImg.tablet}
									quality={100}
									priority
									fill={true}
									sizes="100vw"
									style={{
										objectFit: "contain",
										objectPosition: "right bottom",
										pointerEvents: "none",
									}}
								/>
							</HeroImageTablet>
							<HeroImageMobile>
								<Image
									unoptimized
									alt=""
									src={heroImg.mobile}
									width="880"
									height="488"
									quality={100}
									priority
									style={{
										width: "100%",
										height: "auto",
										pointerEvents: "none",
									}}
								/>
							</HeroImageMobile>
						</HeroImage>
					)
				) : useOptimizedHomepageHero ? (
					<HeroImage>
						<HeroImageResponsive>
							<source media="(max-width: 767px)" srcSet={homepageHeroMobile.srcSet} />
							<source media="(max-width: 1199px)" srcSet={homepageHeroTablet.srcSet} />
							<img
								{...homepageHeroDesktop}
								alt=""
								loading="eager"
								fetchPriority="high"
								decoding="async"
								style={{
									width: "100%",
									height: "auto",
									pointerEvents: "none",
								}}
							/>
						</HeroImageResponsive>
					</HeroImage>
				) : (
					<HeroImage>
						<HeroImageDesktop>
							<Image
								unoptimized
								alt=""
								src={heroImg.desktop}
								width="1920"
								height="488"
								quality={100}
								priority
								style={{
									width: "100%",
									height: "auto",
									pointerEvents: "none",
								}}
							/>
						</HeroImageDesktop>
						<HeroImageTablet>
							<Image
								unoptimized
								alt=""
								src={heroImg.tablet}
								width="1920"
								height="488"
								quality={100}
								priority
								style={{
									width: "100%",
									height: "auto",
									pointerEvents: "none",
								}}
							/>
						</HeroImageTablet>
						<HeroImageMobile>
							<Image
								unoptimized
								alt=""
								src={heroImg.mobile}
								width="1920"
								height="800"
								quality={100}
								priority
								style={{
									width: "100%",
									height: "auto",
									pointerEvents: "none",
								}}
							/>
						</HeroImageMobile>
					</HeroImage>
				)}
			</Hero>
		</>
	);
};

export default Slider;
